<template>
  <div>
    <el-drawer
      title="发票详情"
      custom-class="invoice-detial"
      size="400px"
      :visible.sync="drawerVis.invoiceDetial"
      :append-to-body="true"
      :modal="false"
      :wrapperClosable="false"
    >
      <div class="content">
        <div class="apply-info">
          <div class="item">
            <span>申请人：</span>
            <head-img
              :avatar="invoiceInfo.user_info.headimgurl"
              :sex="invoiceInfo.user_info.sex"
              :radius="true"
            ></head-img>
            <span class="name text-popper" v-textPopper>{{invoiceInfo.user_info.nickname}}</span>
          </div>
          <div class="item">
            <span>申请时间：</span>
            <span>{{invoiceInfo.create_time}}</span>
          </div>
          <span class="logo-success" v-if="invoiceInfo.status">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#iconyichuli" />
            </svg>
          </span>
          <span class="logo-wait" v-else>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icondaichuli" />
            </svg>
          </span>
        </div>
        <div class="invoice-item" v-if="invoiceInfo.status">
          <div class="green-tite">
            <span class="green-line"></span>
            <span class="con">发票文件</span>
          </div>
          <div class="invoice-pdf">
            <img :src="invoiceImg" @click.stop="downloadInvoice(invoiceInfo)" class="pdf-img" />
          </div>
        </div>
        <div class="invoice-item">
          <div class="green-tite">
            <span class="green-line"></span>
            <span class="con">开票订单</span>
          </div>
          <div class="invoice-order">
            <el-table :data="invoiceList" highlight-current-rowstyle="width=100%">
              <el-table-column prop="goods_item" label="购买服务/商品" min-width="120"></el-table-column>
              <el-table-column label="规格/数量" min-width="100" align="right">
                <template slot-scope="scope">
                  <span v-if="scope.row.size">{{scope.row.size}}/</span>
                  <span v-if="checkIsComposeGoods(scope.row.fee_code)">{{`${scope.row.portion_number}${isStaff(scope.row.fee_code) ? '个' : '套'}${scope.row.count}年`}}</span>
                  <span v-else-if="isNewLsStaffSeat(scope.row.fee_code)">{{`${scope.row.count}个`}}</span>
                  <span v-else>{{scope.row.count}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="total_price"
                label="付款金额(元)"
                min-width="90"
                align="right"
                :formatter="changeMoney"
              ></el-table-column>
            </el-table>
            <div class="total">
              <span class="con">开票金额</span>
              <span>
                <span class="red sign">￥</span>
                <span class="red money">{{invoiceTotalMoney}}</span>
                <span class="gray">(含税)</span>
              </span>
            </div>
          </div>
        </div>
        <div class="invoice-item">
          <div class="green-tite">
            <span class="green-line"></span>
            <span class="con">抬头信息</span>
          </div>
          <div class="invoice-title">
            <div class="con">
              <span class="company-title">企业名称：</span>
              <span class="text-popper company-name" v-textPopper>{{invoiceInfo.company_name}}</span>
            </div>
            <div class="con"
            >税&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：{{invoiceInfo.company_uscc}}</div>
          </div>
        </div>
      </div>
      <div class="footer" v-if="invoiceInfo.status">
        <button class="my-button" @click="downloadInvoice(invoiceInfo)">下载发票</button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { qiniuExportURLPrefix } from '@/config/config'
import { 
  checkFeeInfo, 
  PF_SELF_SERVICE_PART,
  PF_SELF_SERVICE_ANNUAL_FEE,
  PF_STAFF_NUM,
  NEW_LS_STAFF_SEAT
 } from '../const'

export default {
  data() {
    return {
      drawerVis: {
        invoiceDetial: false, // 发票详情
      }, // drawer的显示与关闭
      invoiceList: [], // 发票文件详情
      invoiceInfo: {
        fee_record_infos: '',
        user_info: '',
      }, // 发票详情信息
      invoiceImg: require('@/assets/images/invoice.jpg'), // 发票图片的模板
    }
  },

  computed: {
    /**
     * 计算开票订单的总金额
     */
    invoiceTotalMoney: function() {
      return this.invoiceList.reduce((item, current) => item += current.total_price, 0).toFixed(2)
    },
  },

  methods: {
    /**
     * 打开drawer
     */
    open(data) {
      let item = JSON.parse(JSON.stringify(data))
      this.qiniuExportURLPrefix = qiniuExportURLPrefix
      item.preview_url = undefined
      this.invoiceInfo = item
      this.drawerVis.invoiceDetial = true

      this.invoiceList = item.fee_record_infos.map(item => {
        const paymentDetail = item.payment_detail || {}
        const claimItem = paymentDetail.claim_item || {}
        return {
          goods_item: claimItem.payment_target_detail || item.fee_info.goods_item,
          fee_code: item.fee_info.fee_code,
          count: item.count,
          portion_number: item.portion_number,
          size: claimItem.quantity_text || paymentDetail.period_text || item.fee_info.size,
          total_price: item.total_price,
        }
      })
    },

    checkIsComposeGoods(code) {
      return checkFeeInfo(code, [PF_SELF_SERVICE_PART, PF_SELF_SERVICE_ANNUAL_FEE, PF_STAFF_NUM])
    },
    isNewLsStaffSeat(code) {
        return checkFeeInfo(code, [NEW_LS_STAFF_SEAT])
    },
    isStaff(code) {
        return checkFeeInfo(code, [PF_STAFF_NUM])
    },

    /**
     * 改变钱数额的显示方式
     * @param {Object} row 当前列的对象
     */
    changeMoney(row) {
      return this.formatterMoney(row.total_price)
    },

    /**
     * 格式化钱的显示，已**.**的格式显示
     * @param {number} value
     */
    formatterMoney(value) {
      if (String(value).includes(".")) {
        if (String(value).split(".")[1].length === 2) {
          return `${value}`;
        } else if (String(value).split(".")[1].length === 1) {
          return `${value}0`;
        } else {
          return value.toFixed(2)
        }
      } else {
        return `${value}.00`;
      }
    },

    /**
     * 下载发票
     * @param {Object} item 所点击行的对象
     */
    downloadInvoice(item) {      
      this.$fetch.post({
        url: '/common/qiniu?method=get_download_file_url',
        params: {
          key: item.ticket_url
        }
      }).then(res => {
        window.open(res.private_url)
      })
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-drawer__header {
  margin-bottom: 0;
}
/deep/ .el-drawer__body {
  overflow-y: auto;
}
/deep/ .el-table__row {
  > td {
    border-bottom-width: 0;
  }
}
/deep/ .el-table::before {
  height: 0;
}

.invoice-detial {
  .content {
    padding: 20px 12px 65px;

    .apply-info {
      position: relative;
      height: 68px;
      width: 100%;
      background: #f0f0f0;
      border-radius: 6px;
      overflow: hidden;

      .item {
        padding: 8px 0 0 8px;
        font-size: 14px;
        line-height: 20px;

        .name {
          padding-left: 4px;
          max-width: 142px;
        }
      }

      .logo-success {
        position: absolute;
        top: -4px;
        right: -4px;

        .icon {
          width: 68px;
          height: 68px;
        }
      }

      .logo-wait {
        position: absolute;
        top: 8px;
        right: 9px;

        .icon {
          width: 72px;
          height: 24px;
        }
      }
    }

    .invoice-item {
      margin-top: 20px;

      .invoice-title {
        .con {
          font-size: 14px;
          line-height: 20px;
          height: 20px;
          color: #333;
          margin-top: 12px;

          .company-title {
            display: inline-block;
            vertical-align: bottom;
          }

          .company-name {
            max-width: 290px;
          }
        }
      }

      .invoice-order {

        /deep/ .el-table__header-wrapper {
          border: 1px solid #ebebeb;
          border-bottom: none;

          th {
            background: #FFF !important;
            .cell {
              font-size: 14px;
              color: #999;
              line-height: 20px;
            }
          }

          .has-gutter {
            th {
              border-bottom: 0;
              .cell {
                font-weight: 600;
              }
            }
          }
        }

        .total {
          height: 44px;
          padding: 8px 12px;
          border-top: 1px dashed #ebebeb;
          border-left: 1px solid #ebebeb;
          border-right: 1px solid #ebebeb;
          border-bottom: 1px solid #ebebeb;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .con {
            font-size: 14px;
            font-weight: 600;
            color: #333;
          }

          .red {
            color: #ff533a;
          }

          .sign {
            font-size: 14px;
          }

          .money {
            font-size: 22px;
            font-weight: 600;
          }

          .gray {
            color: #999;
            font-size: 14px;
          }
        }
      }

      .invoice-pdf {
        width: 240px;
        height: 140px;
        padding: 7px;
        background: rgba(235, 235, 235, 0.10);
        border-radius: 6px;
        border: 1px dashed #ebebeb;

        .pdf-img {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
    }

    .green-tite {
      margin-bottom: 12px;

      .green-line {
        display: inline-block;
        width: 4px;
        height: 20px;
        background: #08a681;
        border-radius: 2px;
        margin-right: 4px;
        vertical-align: top;
      }

      .con {
        color: #333;
        font-size: 14px;
        font-weight: bolder;
        line-height: 20px;
      }
    }
  }

  .footer {
    position: absolute;
    height: 50px;
    width: 100%;
    bottom: 0px;
    background: #fff;
    border-top: 1px solid #ebebeb;

    .my-button {
      position: absolute;
      top: 7px;
      right: 12px;
    }
  }

}
</style>
